import { useModalState } from '../../../hooks/useModalState';
import { useApplicationContext } from '../../context/ApplicationContext/ApplicationContext';
import { StatusType } from '../../orders/order.types';
import { handleChangeAndBlurParams } from '../types/generalSettingsPage.types';

interface UseBypassOrderOnApprovalSettingModalParams {
  handleChangeAndBlur: (params: handleChangeAndBlurParams) => Promise<void>;
}

export function useBypassOrderOnApprovalAlertModal({
  handleChangeAndBlur,
}: UseBypassOrderOnApprovalSettingModalParams) {
  const { integrations } = useApplicationContext();

  const { isOpen, openModal, closeModal } = useModalState();

  const handleBypassOrderOnApprovalAlert = (checked: boolean) => {
    if (!checked) {
      return handleChangeBypassOrderOnApproval(checked);
    }

    const hasIntegrationOnApproval = integrations?.some(
      (item) => item.active && item.integrationTrigger === StatusType.ON_APPROVAL,
    );

    if (hasIntegrationOnApproval) {
      openModal();
    } else {
      handleChangeBypassOrderOnApproval(checked);
    }
  };

  const handleChangeBypassOrderOnApproval = async (value: boolean) => {
    await handleChangeAndBlur({
      value: value,
      name: 'bypassOrderOnApprovalOnReadyForDelivery',
    });

    closeModal();
  };

  return {
    isOpen,
    closeModal,
    handleBypassOrderOnApprovalAlert,
    handleChangeBypassOrderOnApproval,
  };
}
